// extracted by mini-css-extract-plugin
export default {"root":"header_root__2imoB","menuButton":"header_menuButton__yTgRu","title":"header_title__IvpjC","button":"header_button__8Wjfa","language":"header_language__0yeZ7"};